import { Textarea } from '@/components/ui/textarea';
import { FormSection } from './FormSection';
import { useTranslation } from 'react-i18next';

interface MenuItemDescriptionProps {
  description: string;
  onDescriptionChange: (value: string) => void;
}

export function MenuItemDescription({
  description,
  onDescriptionChange,
}: MenuItemDescriptionProps) {
  const { t } = useTranslation();

  return (
    <FormSection title='description' htmlFor='description'>
      <Textarea
        id='description'
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        placeholder={t('itemDescriptionPlaceholder')}
        className='resize-none'
        rows={3}
      />
    </FormSection>
  );
}
